angular.module('dpw.components')

    .factory('announcementUtils', ['api', '$q', 'dpwStorage', function (api, $q, dpwStorage) {
        var ANNOUNCEMENTS_STORE_KEY = 'announcements';
        var announcements = [];

        return {
            /**
             * Return Important Announcements.
             * @param {Boolean} fetchAll - Fetch all announcements or not.
             * @returns {*}
             */
            getImportantNews: function (fetchAll) {
                var deferred = $q.defer();

                if (announcements.length > 0) {
                    deferred.resolve(announcements);
                } else {
                    api.getImportantNews(fetchAll).success(function (data) {
                        if (data.status.status === 'SUCCESS') {
                            if (data.posts && data.posts.length > 0) {
                                announcements = data.posts;
                                deferred.resolve(announcements);
                            } else {
                                deferred.reject(data);
                            }
                        } else {
                            deferred.reject(data);
                        }
                    }).error(function (data) {
                        deferred.reject(data);
                    });
                }

                return deferred.promise;
            },
            markAsRead: function (announcements) {
                var result = _.map(announcements, function (announcement) {
                    announcement.date_read = announcement.date_updated;
                    return announcement;
                });

                try {
                    dpwStorage.setItem('announcements', angular.toJson(result), false);
                } catch (e) {
                    RCDPW.console.warn('Save announcements to localStorage failed: ', e);
                }

                return result;
            },
            getLocalAnnouncements: getLocalAnnouncements,
            getUnReadAnnouncements: function (announcements) {
                var maintenanceAnnouncements = [];
                var importantUpdates = [];
                var generalAnnouncements = [];
                var notMaintenance = [];
                var localAnnouncements = getLocalAnnouncements();

                // Use the same Timezone(PST) as Blog Server.
                var DATE_TO_COUNT = moment('2016-06-01 00:00:00 -8', 'YYYY-MM-DD HH:mm:ss Z');

                _.each(announcements, function (announcement) {
                    var itemInLocal = _.find(localAnnouncements, function (localAnnouncement) {
                        return localAnnouncement.id === announcement.id;
                    });
                    var isUnread = (!itemInLocal || itemInLocal.date_read !== announcement.date_updated) &&
                        moment(announcement.date_updated + ' -8', 'YYYY-MM-DD HH:mm:ss Z').isAfter(DATE_TO_COUNT);

                    if (isUnread) {
                        switch (announcement.priority) {
                            case 0:
                                maintenanceAnnouncements.push(announcement);
                                break;
                            case 1:
                                importantUpdates.push(announcement);
                                break;
                            case 2:
                                generalAnnouncements.push(announcement);
                                break;
                        }
                    }
                });

                notMaintenance = [].concat(importantUpdates, generalAnnouncements);

                return {
                    maintenance: clean(maintenanceAnnouncements),
                    important: clean(importantUpdates),
                    general: clean(generalAnnouncements)
                };

                function clean(items, undefined) {
                    return _.remove(items, undefined);
                }
            }
        };

        function getLocalAnnouncements() {
            var result = [];

            try {
                result = angular.fromJson(dpwStorage.getItem(ANNOUNCEMENTS_STORE_KEY));
            } catch (e) {
                RCDPW.console.warn('Get announcements from localStorage failed: ', e);
            }

            return result;
        }
    }])

    /**
     * @ngdoc directive
     * @name dpwAnnouncementHint
     * @restrict EA
     * @example
     * <dpw-announcement-hint></dpw-announcement-hint>
     */
    .directive('dpwAnnouncementHint', [function () {
        return {
            restrict: 'EA',
            scope: false,
            templateUrl: 'dpw-announcement-hint.html',
            controllerAs: 'hint',
            controller: ['announcementUtils', 'helpers', function (announcementUtils, helpers) {
                var self = this;
                var shouldShowAnnouncementsHint = !RCDPW.isAdminSite && RCDPW.isLogin;

                shouldShowAnnouncementsHint && announcementUtils.getImportantNews(true).then(function (announcements) {
                    if (helpers.matchPage(RCDPW.entries.announcements)) {
                        announcementUtils.markAsRead(announcements);
                    }

                    self.unreadItems = announcementUtils.getUnReadAnnouncements(announcements);
                    self.unreadItemsCount = self.unreadItems.general.length +
                        self.unreadItems.important.length +
                        self.unreadItems.maintenance.length;
                });
            }]
        };
    }]);
